<svelte:window bind:scrollY={y} />

<nav class="scrolled">
  <a href="/">
    <img class="logo" alt="TietoEVRY logo" src="/res/logo.svg">
  </a>

  <div class="menu">
    <ul>
      <li><a on:click|preventDefault={setTour} href="/tour">VIRTUAL TOUR</a></li>
      <li><a on:click|preventDefault={showWorks} href="/work">WORK</a></li>
      <li><a on:click|preventDefault={showPlay} href="/play">PLAY</a></li>      
    </ul>  

    <a href="https://www.tieto.com/en/careers/search-our-jobs/?area=&amp;country=Latvia&amp;city=&amp;q=" target="_blank"><button class="apply">Apply</button></a>
  </div>
</nav>

<style type="text/scss">
nav{
  position:fixed;
  top:0px;
  width:100%;
  z-index:5;
  height:80px;    
  transition:background-color 300ms ease-in-out;

  .logo{    
    top:0px; left:0px;
    margin-top:15px;
    margin-left:10px;   
    @media( min-width:1024px ){  
      margin-left:70px;   
    }
  }
  .menu{
    float:right;
    display:flex;
    flex-direction:row;
    margin:12px;
    margin-right:70px;
    ul{
      display:flex;
      margin-right:30px;
      li{
        a{
          color:var(--titles);
          transition:color 300ms ease-in-out;
        }      
        padding:3px;
        &:after{
          content:" / ";
          color:var(--titles);
        }
        &:last-child{
          &:after{
            content:"";
          }
        }
      }
    }

    button.apply{
      background-color:var(--success);
      margin-top:8px;
      &:hover{
        background-color:#FFF;
        color:var(--titles);
      }
    }
  }

  &.scrolled{    
    background-color:#002b45;    
    .menu{
      ul{
        li{
          a{ 
            color:#FFF; 
            &:after{
              color:#FFF; 
            }
          }
        }
      }
    }
  }
}
@media( max-width:1024px ){  
  nav{
    .logo{
      width:150px;
    }
    &.scrolled{
      background-color:transparent;
    }
  
    .menu{
      /*display:none;*/
      /*flex-direction:column;
      margin:10px;
      float:right;
      text-align:right;*/
      a{
        position:absolute;
        right:10px;
        top:0px;
        display:none;
	      @media( orientation:portrait ){
          display:block;
	      }
      }
      ul{
        display:none;        
      }
    }
  }
}
</style>

<script>
import { section } from '../stores/navigation'

let lastSection = ''
section.subscribe( s => {
  lastSection = s
} )

const showWorks = () => {
  setTimeout( () => { window.scrollTo({ top:window.innerHeight+50, behavior: 'smooth' }) } , 100 )  
  expand()  
}

const showPlay = () => {
  setTimeout( () => { window.scrollTo({ top:window.innerHeight+1400, behavior: 'smooth' }) } , 100 )
  expand()  
}

const expand = () => {
  section.set('expand')
}

const setTour = () => {  
  section.set('tour')
  setTimeout( () => { window.scrollTo({ top:0, behavior: 'smooth' }) } , 100 )  
}

let y = 0
</script>